import React from 'react';
import { SupportedLanguage } from '../../types/language';
import { useTranslation } from 'react-i18next';

interface ThreatFilterSectionProps {
  selectedCategories: Set<string>;
  onFilterChange: (categories: Set<string>) => void;
  language: SupportedLanguage;
  onShowHelp?: () => void;
}

export const ThreatFilterSection: React.FC<ThreatFilterSectionProps> = ({
  selectedCategories,
  onFilterChange,
  language,
  onShowHelp,
}) => {
  const { t } = useTranslation();
  
  return (
    <div className="sticky top-0 z-30 bg-white/90 backdrop-blur supports-[backdrop-filter]:bg-white/70 border-b border-gray-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2">
        <div className="flex items-center justify-between">
          {/* Category segmented control */}
          <div className="inline-flex rounded-md border border-gray-200 bg-gray-50 p-1 shadow-sm">
            <button
              onClick={() => onFilterChange(new Set(['MILITARY']))}
              className={`px-4 py-2 text-sm rounded-md font-medium transition-colors ${
                selectedCategories.size === 1 && selectedCategories.has('MILITARY')
                  ? 'bg-red-100 text-red-800 border border-red-200 shadow'
                  : 'text-gray-700 hover:bg-gray-100'
              }`}
            >
              {t('public.threatFocus.militaryOnly')}
            </button>
            <button
              onClick={() => onFilterChange(new Set(['MILITARY', 'CYBER', 'DIPLOMATIC', 'ECONOMIC', 'INFORMATION_WARFARE']))}
              className={`ml-1 px-4 py-2 text-sm rounded-md font-medium transition-colors ${
                selectedCategories.size > 1
                  ? 'bg-blue-100 text-blue-800 border border-blue-200 shadow'
                  : 'text-gray-700 hover:bg-gray-100'
              }`}
            >
              {t('public.threatFocus.allThreats')}
            </button>
          </div>
          {/* Right side actions */}
          <div className="hidden sm:flex items-center gap-3">
            <button
              onClick={onShowHelp}
              className="text-sm text-blue-600 hover:text-blue-700 underline"
            >
              {t('public.header.howDoesItWork')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
